import {useEffect, useState} from "react";
import { Input, Radio, Space } from 'antd';

const OptionSelect = (props) => {
    const {onOptionChange, options, setIsValid, isValid} = props;
    const [value, setValue] = useState('');


    useEffect(() => {
        if(options.length === 1){
            setValue(options[0].value)
            setIsValid(true);
        }
    }, [options, setIsValid]);


    const RadioOptions = options?.map((option, index) => {
        return (
            <Radio key={index} value={option.value}>{option.value}</Radio>
        )
    })

    const handleOnOptionsChange = (e)=>{
        setValue(e.target.value);
        onOptionChange(e.target.value);
        setIsValid(true)
    }


    return (
        <Radio.Group 
            onChange={handleOnOptionsChange} 
            value={value} 
            options={{'required':true}}
            style={!isValid ? {border: '1px solid #ff4d4f', borderRadius: '6px', padding: '4px'} : {}}
        >
            <Space direction="vertical">
                {RadioOptions}
            </Space>
        </Radio.Group>
    )

}

export default OptionSelect
